import { Dialog, DialogContent, DialogProps, DialogTitle } from '@material-ui/core';
import React, { useState } from 'react';
import { ExtendedRadioGroup } from 'framework/components/ExtendedRadioGroup';
import { CancelSubmitDialogActions } from 'framework/forms/CancelSubmitDialogActions';
import { OriginalOrLatestDocumentExportMode } from 'gen/ApiClient';
import { useLocalization } from 'localization/useLocalization';

interface IProps extends DialogProps {
	confirm: (value: OriginalOrLatestDocumentExportMode) => void;
	cancel: VoidFunction;
}

export const SelectOriginalOrLatestDocumentExportModeDialog = ({ confirm, cancel, ...rest }: IProps) => {
	const strings = useLocalization();
	const [value, setValue] = useState<OriginalOrLatestDocumentExportMode>('OriginalDocument');

	return (
		<Dialog
			scroll='paper'
			fullWidth
			{...rest}>
			<DialogTitle>{strings.selectWhat(strings.mode)}</DialogTitle>
			<DialogContent
				className='df-col'
				dividers>
				<ExtendedRadioGroup<OriginalOrLatestDocumentExportMode>
					selected={value}
					setSelected={setValue}
					options={[
						{ value: 'OriginalDocument', label: strings.original, caption: strings.useOriginalDocument },
						{ value: 'LastDocument', label: strings.latest, caption: strings.useLatestDocument },
					]}
				/>
			</DialogContent>
			<CancelSubmitDialogActions
				onSubmit={() => confirm(value)}
				cancel={cancel}
				isSubmitting={false}
				submitText={strings.select}
			/>
		</Dialog>
	);
};
